export default "__VITE_ASSET__DSoB9QZ7__"